import React from 'react';
import { CheckCircle2, HardHat } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhyChooseUsSection() {
  const reasons = [{
    title: 'We Show Up',
    desc: "We know that's the bare minimum — but in this industry, it's rarer than it should be. When you book with us, we're there."
  }, {
    title: 'We Communicate',
    desc: "No ghosting. No guessing. You always know what's happening with your project."
  }, {
    title: 'We Do It Right',
    desc: "Every job — big or small — gets our full attention and craftsmanship. We don't cut corners because your home deserves better than that."
  }, {
    title: 'We Serve YOUR Community',
    desc: 'We live and work in Northeast Ohio. Mentor, Willoughby, Kirtland, Mayfield Heights, Chagrin Falls, Solon, Twinsburg, Beachwood, Shaker Heights, Moreland Hills — these are our neighbors. We take that seriously.'
  }, {
    title: 'FREE Estimates — Always',
    desc: 'No commitment. No pressure. Just an honest conversation about what your property needs and what it will cost.'
  }];
  return <section id="why-us" className="py-24 bg-white" data-id="element-358">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-359">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-360">
          <div className="lg:col-span-5" data-id="element-361">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="sticky top-32" data-id="element-362">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#1B4332]/10 text-[#1B4332] mb-6" data-id="element-363">
                <HardHat size={32} data-id="element-364" />
              </div>
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-6" data-id="element-365">
                Why Northeast Ohio Homeowners Choose I&A
              </h2>

              <blockquote className="border-l-4 border-[#D4A373] pl-6 py-2 my-8 bg-gray-50 rounded-r-lg" data-id="element-366">
                <p className="text-xl font-serif italic text-gray-700" data-id="element-367">
                  "Most contractors talk a big game. I&A just does the work —
                  and the results speak for themselves."
                </p>
              </blockquote>

              <p className="text-lg text-gray-600" data-id="element-368">
                Here's what makes us different from the rest of the pack:
              </p>
            </motion.div>
          </div>

          <div className="lg:col-span-7" data-id="element-369">
            <div className="space-y-8" data-id="element-370">
              {reasons.map((reason, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex gap-5 bg-white p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-371">
                  <div className="flex-shrink-0" data-id="element-372">
                    <CheckCircle2 className="w-8 h-8 text-[#1B4332]" data-id="element-373" />
                  </div>
                  <div data-id="element-374">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-375">
                      {reason.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-376">
                      {reason.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}